import localeDa from '@angular/common/locales/da';
import localeDeCh from '@angular/common/locales/de-CH';
import localeEn from '@angular/common/locales/en';
import localeFrBe from '@angular/common/locales/fr-BE';
import localeFrCh from '@angular/common/locales/fr-CH';
import localeNl from '@angular/common/locales/nl';
import localeNlBe from '@angular/common/locales/nl-BE';
import arialBold from '@capsizecss/metrics/arial/700';
import arial from '@capsizecss/metrics/arial/regular';
import barlowSemiBold from '@capsizecss/metrics/barlow/600';
import barlowBold from '@capsizecss/metrics/barlow/700';
import barlow from '@capsizecss/metrics/barlow/regular';
import helveticaNeueLight from '@capsizecss/metrics/helveticaNeue/300';
import helveticaNeueBold from '@capsizecss/metrics/helveticaNeue/700';
import helveticaNeue from '@capsizecss/metrics/helveticaNeue/regular';
import nunitoSansLight from '@capsizecss/metrics/nunitoSans/200';
import { BrandConfig } from '../../../storefrontlib/src/layout/main/brand-config';

export const config: BrandConfig = {
  iconPathPrefix: '/assets-scaldia',
  fonts: {
    primary: {
      fallback: [helveticaNeue, arial],
      fontFaceProperties: { fontDisplay: 'optional' },
      src: {
        woff2: '/assets-scaldia/fonts/Barlow-Regular.woff2',
        woff: '/assets-scaldia/fonts/Barlow-Regular.woff',
      },
      metrics: barlow,
    },
    'primary-light': {
      fallback: [<any>helveticaNeueLight, arial],
      fontFaceProperties: { fontDisplay: 'optional' },
      src: {
        woff2: '/assets-scaldia/fonts/nunitosans-light.woff2',
        woff: '/assets-scaldia/fonts/nunitosans-light.woff',
      },
      metrics: nunitoSansLight,
    },
    secondary: {
      fallback: [helveticaNeue, arial],
      fontFaceProperties: { fontDisplay: 'optional' },
      src: {
        woff2: '/assets-scaldia/fonts/Barlow-SemiBold.woff2',
        woff: '/assets-scaldia/fonts/Barlow-SemiBold.woff',
      },
      metrics: barlowSemiBold,
    },
    'secondary-bold': {
      fallback: [helveticaNeueBold, arialBold],
      fontFaceProperties: { fontDisplay: 'swap' },
      metrics: barlowBold,
      src: {
        woff2: '/assets-scaldia/fonts/Barlow-Bold.woff2',
        woff: '/assets-scaldia/fonts/Barlow-Bold.woff',
      },
    },
  },
  localeData: [[localeDa], [localeDeCh], [localeEn], [localeFrBe], [localeFrCh], [localeNl], [localeNlBe]],
  stylesheets: ['scaldia.css'],
  links: [
    { rel: 'shortcut icon', type: 'image/x-icon', href: '/assets-scaldia/icons/favicon.ico' },
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/assets-scaldia/icons/favicon-32x32.png' },
    { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/assets-scaldia/icons/favicon-16x16.png' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/assets-scaldia/icons/apple-touch-icon.png' },
    { rel: 'apple-touch-icon-precomposed', href: '/assets-scaldia/icons/apple-touch-icon-precomposed.png' },
    { rel: 'mask-icon', href: '/assets-scaldia/icons/safari-pinned-tab.svg', color: '#0057b4' },
    { rel: 'manifest', href: '/assets-scaldia/manifest.webmanifest' },
    { rel: 'preload', href: '/assets-scaldia/fonts/nunitosans-light.woff2', as: 'font', type: 'font/woff2', crossorigin: '' },
    {
      rel: 'preload',
      href: '/assets-scaldia/fonts/Barlow-Bold.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: '',
    },
    {
      rel: 'preload',
      href: '/assets-scaldia/fonts/Barlow-Regular.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: '',
    },
    {
      rel: 'preload',
      href: '/assets-scaldia/fonts/Barlow-SemiBold.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: '',
    },
  ],
  meta: [
    { name: 'application-name', content: 'Scaldia' },
    { name: 'msapplication-config', content: '/assets-scaldia/browserconfig.xml' },
    { name: 'theme-color', content: '#ffffff' },
  ],
};
